export const WHATSAPP_AGENDA_CARE_URL = "https://wa.me/5584998070040";

export const OPCOES_LOCAL_ATENDIMENTO = [
  { value: "SEDE", label: "Sede" },
  { value: "DOMICILIO", label: "Domicílio" },
];

export const OPCOES_MEDICACAO_ORIGEM = [
  { value: "CLIENTE", label: "Cliente" },
  { value: "DNA_CARE", label: "DNA Care" },
];

export const OPCOES_PAGAMENTO_STATUS = [
  { value: "PENDENTE", label: "Pendente" },
  { value: "EFETUADO", label: "Efetuado" },
];

export const OPCOES_SITUACAO_AGENDAMENTO = [
  {
    value: "Pendente",
    label: "Pendente",
    backgroundColor: "#FFF3E0",
    color: "#E65100",
  },
  {
    value: "Confirmado",
    label: "Confirmado",
    backgroundColor: "#E3F2FD",
    color: "#1565C0",
  },
  {
    value: "Realizado",
    label: "Realizado",
    backgroundColor: "#E8F5E9",
    color: "#2E7D32",
  },
  {
    value: "Não Realizado",
    label: "Não Realizado",
    backgroundColor: "#FFEBEE",
    color: "#C62828",
  },
];
